import React, { useCallback, useEffect, useState } from 'react';
import Package from '../../assets/images/package.svg';
import { useLanguage } from '../../locale/useLanguage';
import { useHistory, useLocation } from 'react-router-dom';
import { Routes } from '../../routes/types';
// import dayjs from 'dayjs';
import { WeekDay } from '../../models';
import { EndFlowScreen } from '../../components/EndFlowScreen/EndFlowScreen';
import { indexOf } from 'lodash';

type ConfirmationOpeningHoursViewProps = {};

type ConfirmationOpeningHoursViewRouteParams = {
  openingHours: {
    conciergeMorningFromHour?: string;
    conciergeMorningToHour?: string;
    conciergeAfternoonFromHour?: string;
    conciergeAfternoonToHour?: string;
    days: WeekDay[];
  };
};

const sorter = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const ConfirmationOpeningHoursView: React.FC<
  ConfirmationOpeningHoursViewProps
> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const location = useLocation<ConfirmationOpeningHoursViewRouteParams>();
  const [content, setContent] = useState<Array<{ [key: string]: string }>>([]);
  const [button, setButton] = useState<{ text: string; onClick: () => void }>();

  useEffect(() => {
    if (!location.state) {
      history.replace(Routes.Home);
    } else {
      setContent(
        location.state.openingHours.days
          .sort((a, b) => indexOf(sorter, a) - indexOf(sorter, b))
          .map((e) => {
            return {
              title: `${t(`weekdays.${e}`)}:`,
              label: `${location.state.openingHours.conciergeMorningFromHour} - ${location.state.openingHours.conciergeMorningToHour} / ${location.state.openingHours.conciergeAfternoonFromHour} - ${location.state.openingHours.conciergeAfternoonToHour}`,
            };
          })
      );
      setButton({
        text: t('paymentSuccess.trackOrder'),
        onClick: goToTracking,
      });
    }
  }, [history, location.state]);

  const goToTracking = useCallback(() => {
    history.push(Routes.Home);
  }, [history]);

  return (
    <>
      <EndFlowScreen
        buttonPrimary={button}
        image={Package}
        title={t('openingHours.timesEntered')}
        content={content}
        splitContent={false}
      />
    </>
  );
};
